import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLine from "./components/LiftLine";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";

const Lift16 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift16"
			 className={getLiftClass(isOpen, activeLiftId === '16', state)}
			 transform="translate(2303.000000, 416.000000)"
		>
			<LiftLine x1="13" y1="13" x2="72.5" y2="105.5" color={colors[0]}/>
			<LiftLabelTypeSeat
				seatCount="4"
				animationPart="4"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				coords="36.500000, 57.966002"
			/>

			<LiftLine x1="101.5" y1="143.5" x2="202.138327" y2="268.943544" color={colors[0]}/>
			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13">16</tspan>} state={state}/>

			<g id="Labe-lift" transform="translate(192.000000, 257.000000)">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(204.500000, 269.500000) scale(-1, 1) rotate(-219.000000) translate(-204.500000, -269.500000) "
				points="199 269.5 210 264 207.628513 269.5 210 275"/>
		</g>
	);
};


Lift16.propTypes = {};

export default Lift16;
